import { isWeb } from "@stepapp/core";
import { palette, SvgIcon, spacing, Touchable, Typography } from "@stepapp/ui";
import React from "react";
import { useTranslation } from "react-i18next";
import { Platform, StyleSheet } from "react-native";
import { useAppSelector } from "../../hooks";

type Props = {
  onPress?: () => void;
};

const PickCityButton = ({ onPress }: Props) => {
  const { t } = useTranslation();
  const { city } = useAppSelector(({ appConfig }) => appConfig);

  return (
    <Touchable activeOpacity={isWeb ? 0.6 : 1} onPress={onPress} style={styles.cityContainer}>
      <Typography type="accent" variant="newH3" style={styles.cityText}>
        {city || t("screens.dashboard.chooseCity")}
      </Typography>
      <SvgIcon
        color={palette.primary.accent}
        name="chevron-down"
        size={20}
        style={styles.cityIcon}
      />
    </Touchable>
  );
};

export default React.memo(PickCityButton);

const styles = StyleSheet.create({
  cityContainer: {
    alignItems: "center",
    flexDirection: "row",
    marginLeft: spacing.unit,
  },
  cityText: {
    textDecorationLine: "underline",
    textDecorationStyle: "solid",
    ...Platform.select({
      web: { textUnderlineOffset: 2, textDecorationThickness: 1 },
    }),
  },
  cityIcon: {
    marginBottom: 4,
  },
});
